import { MiddlewareConsumer, Module } from '@nestjs/common';
import { ServerAuthModule } from '@ip6m/server/auth';
import { ServerDataAccessUserModule } from '@ip6m/server/data-access-user';
import { ProfileController } from './controllers/profile.controller';
import { ContextMiddleware } from '@ip6m/server/auth';
import { ServerFeatureConfigurationModule } from '@ip6m/server/feature-configuration';

@Module({
  imports: [ServerDataAccessUserModule, ServerAuthModule, ServerFeatureConfigurationModule],
  controllers: [ProfileController],
})
export class ServerFeatureSelfCareModule {
  configure(consumer: MiddlewareConsumer): void {
    consumer.apply(ContextMiddleware).forRoutes(ProfileController);
  }
}
